(function () {
  var root = document.getElementById('nexo-chat');
  if (!root) return;

  var endpoint = root.getAttribute('data-nexo-chat-endpoint');
  var bubble = document.getElementById('nexo-chat-bubble');
  var windowEl = document.getElementById('nexo-chat-window');
  var closeBtn = document.getElementById('nexo-chat-close');
  var messagesEl = document.getElementById('nexo-chat-messages');
  var form = document.getElementById('nexo-chat-form');
  var input = document.getElementById('nexo-chat-input');
  var hint = document.getElementById('nexo-chat-hint');

  var SESSION_KEY = 'nexo_chat_session_id';
  var sessionId = localStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = 'sess_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
    localStorage.setItem(SESSION_KEY, sessionId);
  }

  function money(amount) {
    if (amount == null) return '';
    return '$' + Number(amount).toLocaleString('es-CO');
  }

  function scrollToBottom() {
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  // Escapa HTML antes de convertir URLs en <a> — así el texto del modelo
  // nunca puede inyectar markup, pero un link que venga en el mensaje (ej.
  // el fallback de "aquí tienes el link directo: ...") sí queda clicable en
  // vez de quedarse como texto plano sin poder tocarlo.
  function escapeHtml(str) {
    return str.replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // En vez de pintar la URL completa (se desborda del cuadro del mensaje),
  // se muestra como un botón corto "Ver producto →" que abre el link real.
  function linkify(escapedText) {
    return escapedText.replace(/(https?:\/\/[^\s<]+)/g, function (url) {
      return '<a class="nexo-chat-inline-link" href="' + url + '" target="_blank" rel="noopener">Ver producto →</a>';
    });
  }

  function addBotText(text) {
    var el = document.createElement('div');
    el.className = 'nexo-chat-msg nexo-chat-msg-bot';
    el.innerHTML = linkify(escapeHtml(text));
    messagesEl.appendChild(el);
    scrollToBottom();
  }

  function addUserText(text) {
    var el = document.createElement('div');
    el.className = 'nexo-chat-msg nexo-chat-msg-user';
    el.textContent = text;
    messagesEl.appendChild(el);
    scrollToBottom();
  }

  function addProductCard(card) {
    var a = document.createElement('a');
    a.className = 'nexo-chat-card';
    a.href = card.url;
    a.target = '_blank';
    a.rel = 'noopener';

    var img = '';
    if (card.image) {
      img = '<img src="' + card.image + '" alt="' + (card.title || '').replace(/"/g, '') + '" loading="lazy">';
    }

    a.innerHTML =
      img +
      '<div class="nexo-chat-card-body">' +
      '<p class="nexo-chat-card-title">' + (card.title || '') + '</p>' +
      '<div class="nexo-chat-card-foot">' +
      '<span class="nexo-chat-card-price">' + money(card.price) + '</span>' +
      '<span class="nexo-chat-card-cta">Ver producto →</span>' +
      '</div></div>';

    messagesEl.appendChild(a);
    scrollToBottom();
  }

  function addWhatsappButton(url) {
    var a = document.createElement('a');
    a.className = 'nexo-chat-whatsapp';
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener';
    a.innerHTML = '💬 Continuar por WhatsApp';
    messagesEl.appendChild(a);
    scrollToBottom();
  }

  var typingEl = null;
  function showTyping() {
    typingEl = document.createElement('div');
    typingEl.className = 'nexo-chat-msg-typing';
    typingEl.innerHTML = '<span></span><span></span><span></span>';
    messagesEl.appendChild(typingEl);
    scrollToBottom();
  }
  function hideTyping() {
    if (typingEl) {
      typingEl.remove();
      typingEl = null;
    }
  }

  var hintTimeout = null;
  function showHint() {
    if (!hint) return;
    hint.classList.add('is-visible');
    clearTimeout(hintTimeout);
    hintTimeout = setTimeout(function () {
      hint.classList.remove('is-visible');
    }, 7000);
  }
  function hideHint() {
    if (!hint) return;
    hint.classList.remove('is-visible');
    clearTimeout(hintTimeout);
  }

  function openChat(focusInput) {
    windowEl.hidden = false;
    bubble.setAttribute('aria-expanded', 'true');
    hideHint();
    // Al abrir por toque del cliente se enfoca el input; openChat(false) lo evita si algún día se abre sin acción suya.
    if (focusInput !== false) input.focus();
  }
  function closeChat() {
    windowEl.hidden = true;
    bubble.setAttribute('aria-expanded', 'false');
    showHint();
  }

  bubble.addEventListener('click', function () {
    if (windowEl.hidden) openChat();
    else closeChat();
  });
  closeBtn.addEventListener('click', closeChat);

  // El chat YA NO se abre solo (en el celular tapaba la página y confundía). Solo aparece
  // un avisito amable ("Aquí estamos para ti…") una vez por sesión de navegación: se ve unos
  // segundos y desaparece solo. El cliente decide si toca el botón de María.
  try {
    var INTRO_KEY = 'nexo_chat_intro_hint';
    if (!sessionStorage.getItem(INTRO_KEY)) {
      sessionStorage.setItem(INTRO_KEY, '1');
      setTimeout(function () {
        if (windowEl.hidden) showHint();
      }, 4000);
    }
  } catch (e) {
    // sessionStorage puede fallar en modo privado — no es crítico, se omite el avisito.
  }

  // La ventana empieza translúcida (para no tapar la página) y se pone
  // sólida en cuanto el cliente la toca — mouse en desktop, touch en celular.
  function activateWindow() {
    windowEl.classList.add('is-active');
  }
  function deactivateWindow() {
    windowEl.classList.remove('is-active');
  }
  windowEl.addEventListener('mouseenter', activateWindow);
  windowEl.addEventListener('mouseleave', function () {
    if (document.activeElement !== input) deactivateWindow();
  });
  windowEl.addEventListener('touchstart', activateWindow, { passive: true });
  input.addEventListener('focus', activateWindow);
  input.addEventListener('blur', function () {
    if (!windowEl.matches(':hover')) deactivateWindow();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var text = input.value.trim();
    if (!text) return;

    addUserText(text);
    input.value = '';
    input.disabled = true;
    showTyping();

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sessionId: sessionId, message: text }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        hideTyping();
        (data.replies || []).forEach(addBotText);
        (data.productCards || []).forEach(addProductCard);
        if (data.whatsappUrl) addWhatsappButton(data.whatsappUrl);
      })
      .catch(function () {
        hideTyping();
        addBotText('Tuvimos un problema de conexión 😅 ¿lo intentas de nuevo?');
      })
      .finally(function () {
        input.disabled = false;
        input.focus();
      });
  });
})();
